import {
  type MaintenanceChecklistField,
  type MaintenanceChecklistFieldType,
} from '@gb-ticket/shared-types';
import { type ComponentType } from 'react';

import { ChecklistAttachmentField } from '@/products/maintenance/features/protocol-renderer/fields/checklist-attachment-field';
import { ChecklistBooleanField } from '@/products/maintenance/features/protocol-renderer/fields/checklist-boolean-field';
import { ChecklistChoiceField } from '@/products/maintenance/features/protocol-renderer/fields/checklist-choice-field';
import { ChecklistDateField } from '@/products/maintenance/features/protocol-renderer/fields/checklist-date-field';
import { ChecklistInfoField } from '@/products/maintenance/features/protocol-renderer/fields/checklist-info-field';
import { ChecklistNumberField } from '@/products/maintenance/features/protocol-renderer/fields/checklist-number-field';
import { ChecklistTextField } from '@/products/maintenance/features/protocol-renderer/fields/checklist-text-field';
import { ChecklistTimeField } from '@/products/maintenance/features/protocol-renderer/fields/checklist-time-field';

type FieldViewProps = {
  field: MaintenanceChecklistField;
  readOnly?: boolean;
};

type RegistryEntry = ComponentType<FieldViewProps>;

export const maintenanceChecklistFieldViewRegistry: Record<
  MaintenanceChecklistFieldType,
  RegistryEntry
> = {
  info: ({ field }) => (
    <ChecklistInfoField field={field as Extract<MaintenanceChecklistField, { type: 'info' }>} />
  ),
  boolean: ({ field, readOnly }) => (
    <ChecklistBooleanField
      field={field as Extract<MaintenanceChecklistField, { type: 'boolean' }>}
      readOnly={readOnly}
    />
  ),
  choice: ({ field, readOnly }) => (
    <ChecklistChoiceField
      field={field as Extract<MaintenanceChecklistField, { type: 'choice' }>}
      readOnly={readOnly}
    />
  ),
  short_text: ({ field, readOnly }) => (
    <ChecklistTextField
      field={field as Extract<MaintenanceChecklistField, { type: 'short_text' }>}
      readOnly={readOnly}
    />
  ),
  long_text: ({ field, readOnly }) => (
    <ChecklistTextField
      field={field as Extract<MaintenanceChecklistField, { type: 'long_text' }>}
      readOnly={readOnly}
    />
  ),
  integer: ({ field, readOnly }) => (
    <ChecklistNumberField
      field={field as Extract<MaintenanceChecklistField, { type: 'integer' }>}
      readOnly={readOnly}
    />
  ),
  decimal: ({ field, readOnly }) => (
    <ChecklistNumberField
      field={field as Extract<MaintenanceChecklistField, { type: 'decimal' }>}
      readOnly={readOnly}
    />
  ),
  measurement: ({ field, readOnly }) => (
    <ChecklistNumberField
      field={field as Extract<MaintenanceChecklistField, { type: 'measurement' }>}
      readOnly={readOnly}
    />
  ),
  date: ({ field, readOnly }) => (
    <ChecklistDateField
      field={field as Extract<MaintenanceChecklistField, { type: 'date' }>}
      readOnly={readOnly}
    />
  ),
  time: ({ field, readOnly }) => (
    <ChecklistTimeField
      field={field as Extract<MaintenanceChecklistField, { type: 'time' }>}
      readOnly={readOnly}
    />
  ),
  attachment: ({ field, readOnly }) => (
    <ChecklistAttachmentField
      field={field as Extract<MaintenanceChecklistField, { type: 'attachment' }>}
      readOnly={readOnly}
    />
  ),
};
